import { render, staticRenderFns } from "./PostDetails.vue?vue&type=template&id=7201c35a&"
import script from "./PostDetails.vue?vue&type=script&lang=ts&"
export * from "./PostDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports